import * as React from "react";
import { motion } from "framer-motion";
import { MenuItem } from "./MenuItem";

type NavConfig = {
  key: string;
  label: string;
  path: string;
  icon?: React.ReactNode;
};

type NavigationProps = {
  navConfigurations: ReadonlyArray<NavConfig>;
  toggle: () => void;
  isOpen: boolean;
};

const variants = {
  open: {
    display: 'block',
    transition: { staggerChildren: 0.07, delayChildren: 0.2 }
  },
  closed: {
    transition: { staggerChildren: 0.05, staggerDirection: -1, when: "afterChildren" },
    transitionEnd: { display: 'none' }
  }
};

export const Navigation = ({navConfigurations, toggle, isOpen}: NavigationProps) => (
  <motion.ul variants={variants} initial={false} animate={isOpen ? "open" : "closed"} className="mobile-menu-list">
    {navConfigurations.map(navItem => (
      <MenuItem menuItem={navItem} key={navItem.key} toggle={toggle} isOpen={isOpen} />
    ))}
  </motion.ul>
);
